// extracted by mini-css-extract-plugin
module.exports = {"title":"PollDetails_title__7qgdN"};